import { render, staticRenderFns } from "./item_tab_nav.vue?vue&type=template&id=7bfa4e3c&scoped=true&"
import script from "./item_tab_nav.vue?vue&type=script&lang=js&"
export * from "./item_tab_nav.vue?vue&type=script&lang=js&"
import style0 from "./item_tab_nav.vue?vue&type=style&index=0&id=7bfa4e3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfa4e3c",
  null
  
)

export default component.exports